import React, { Component } from 'react';
import { Modal, Button, Spin } from 'antd';
import TableC from '../../../basicElement/TableC';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';

/**
 * 1、确定数据项的顺序
 * 2、将key映射为name
 * 3、获取data中key对应的list
 */
const KeyToNames = {
    'plan_Type_Informed': '计划知情数',
    'actual_Type_Informed': '实际知情数',
    'plan_Type_Filter': '计划筛选数',
    'actual_Type_Filter': '实际筛选数',
    'plan_Type_Random': '计划随机(入组)数',
    'actual_Type_Random': '实际随机(入组)数',
};

class SiteSituation extends Component {
    state = {
        loading: false,
        visible: false,
        columns: [],
        dataSource: [],
    }

    loadData = invSiteId => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.member.querySiteDataList,
            data: { invSiteId },
            doneResult: this.resolveData,
        };
        $.sendRequest(options);
    }

    show = invSiteId => {
        this.setState({ visible: true }, () => {
            this.loadData(invSiteId);
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            columns: [],
            dataSource: [],
        });
    }

    resolveData = (res) => {
        const data = res.data || {};
        const columns = [{
            title: '',
            dataIndex: 'name',
            key: 'name',
            fixed: 'left',
            width: 100
        }];
        const dataSource = [];

        // 根据header构建columns
        (data.header || []).forEach(i => {
            const date = `${i.year}.${i.month}`;
            columns.push({
                title: date,
                dataIndex: date,
                key: date,
                width: 60
            });
        });

        // 遍历KeyToNames，构建dataSource
        for (let key in KeyToNames) {
            const result = { name: KeyToNames[key], primaryKey: key };

            // 获取key对应的数据列表，将其转化为对象
            const list = data[key] || [];
            list.forEach(i => result[`${i.year}.${i.month}`] = i.amount);

            dataSource.push(result);
        }
        this.setState({
            columns,
            dataSource,
            loading: false,
        });
    }

    render() {
        const { loading, visible, columns, dataSource } = this.state;
        return (
            <Modal
                title='中心知情、筛选、随机(入组)情况'
                visible={visible}
                onCancel={this.hide}
                width="1000px"
                maskClosable={false}
                bodyStyle={{ maxHeight: 500 }}
                footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
            >
                <Spin spinning={loading}>
                    <TableC
                        columns={columns}
                        data={dataSource}
                        rowKey="primaryKey"
                        pagination={false}
                        scrollY={380}
                        className="siteSituation"
                    />
                </Spin>
            </Modal>
        );
    }
}

export default SiteSituation;



// WEBPACK FOOTER //
// ./src/components/user/require/components/SiteSituation.js